import { FilterType } from 'UI/constants/defaults';

export const FormFieldsMap = {
  Tone: {
    key: 'tone',
    label: 'Tone',
    type: FilterType.Autocomplete,
    optionsKey: 'tones',
    columns: {
      sm: 3,
      md: 4
    },
    disableClearable: true
  },
  Audience: {
    key: 'audience',
    label: 'Audience',
    type: FilterType.Autocomplete,
    columns: {
      sm: 3,
      md: 3
    },
    optionsKey: 'audiences'
  },
  Length: {
    key: 'length',
    label: 'Length',
    type: FilterType.Autocomplete,
    columns: {
      sm: 3,
      md: 3
    },
    optionsKey: 'lengths'
  },
  Instructions: {
    key: 'instructions',
    label: 'Additional Instructions',
    columns: {
      sm: 10,
      md: 9
    },
    type: FilterType.Input
  }
};

export const AUTOCOMPLETE_FIELDS = Object.values(FormFieldsMap).filter(
  field => field.type === FilterType.Autocomplete
);
